export default __webpack_public_path__ + "static/media/multi-language-background.d67ce0b3.svg";